import { useEffect, useState } from "react";
import { FirebaseOptions, initializeApp } from "firebase/app";
import { getMessaging, getToken, Messaging } from "firebase/messaging";
import { useTheme } from "styled-components";
import { __postAjaxClient } from "utils/misc/fetchClient";
import { CookiesConstants } from "utils/constants";
import { firebaseRegister } from "dataLayer/apisWithoutCache/notificationApi/notification";
import { parseCookies, setCookie } from "utils/nookies";
import { useSsoContext } from "contexts/authSSOContext";
import {permissionLocationAction, permissionNotificationAction} from "../libs/logging/helpers/loggingActions";
import { EnumActionNameLevel3 } from "../libs/logging/types/loggingTypes";
import {isBrowser} from "utils/nookies/utils";

const NO_VALUE = "FIREBASE_CLICKED_NO";

function storeTgtTicketToDB(ticket, country_abbrv, lang, member_id, source) {
  if (typeof indexedDB === "undefined" || typeof indexedDB.open !== "function") return;
  try {
    const open = indexedDB.open("OPENSOOQ_DB", 2);
    const dataItem = {id: 1, ticket, country_abbrv, lang, member_id, source};
    // Create the schema
    open.onupgradeneeded = () => {
      const db = open.result;
      if (!db.objectStoreNames.contains('TicketsStore')) {
        const store = db.createObjectStore("TicketsStore", {keyPath: "id"});
        store.put(dataItem);
      }

    };

    open.onsuccess = () => {
      const db = open.result;
      try {
        const tx = db.transaction("TicketsStore", "readwrite");
        const store = tx.objectStore("TicketsStore");
        store.put(dataItem);
        tx.oncomplete = () => db.close();
      } catch (e) {
        console.log("indexedDB exception", e);
      }
    };
  } catch (e) {
    console.error('failed to open indexedDB', e)
  }
}

export const useFirebase = () => {
  const { locale } = useTheme();
  const { isLoggedInSso } = useSsoContext();

  const [isShown, setIsShown] = useState<boolean>(false);
  const [userClickedYes, setUserClickedYes] = useState<boolean>(false);
  const [userClickedNo, setUserClickedNo] = useState<boolean>(false);
  const cookies = parseCookies();
  const firebaseCookie = cookies[CookiesConstants.FIREBASE_FCM_TOKEN];

  useEffect(() => {
    if (firebaseCookie || window?.Notification?.permission !== "default") {
      setIsShown(false);
    } else {
      setIsShown(true);
    }
  }, []);

  useEffect(() => {
    if (!firebaseCookie && window?.Notification?.permission === "granted") {
      setUserClickedYes(true);
    }
  }, []);

  useEffect(() => {
    const _onLogInSuccess = () => {
      const cookies = parseCookies();
      const token = cookies[CookiesConstants.FIREBASE_FCM_TOKEN]?cookies[CookiesConstants.FIREBASE_FCM_TOKEN]:"";
      token && firebaseRegister(token);
      _storeTgtTicketToDB(); //to update the tgt tct once the login is success
    };
    const _storeTgtTicketToDB = () => {
      const cookies = parseCookies();
      storeTgtTicketToDB(
        [
          cookies[CookiesConstants.TGT_TIMESTAMP],
          cookies[CookiesConstants.TGT_TICKET],
        ],
        cookies[CookiesConstants.COUNTRY],
        cookies[CookiesConstants.LOCALE],
        cookies[CookiesConstants.TRACKING_ID],
        cookies[CookiesConstants.SOURCE]
      );
    };

    _storeTgtTicketToDB(); // be called for logged out

    document.addEventListener("on-login-success-api", _onLogInSuccess);
    return () =>
      document.removeEventListener("on-login-success-api", _onLogInSuccess);
  }, []);


  //commented out because there is no firebase app
  // const firebaseAppId = process.env.NEXT_PUBLIC_CUSTOM_THEME === "shobiddak" ?
  //     process.env.NEXT_PUBLIC_FIREBASE_SHOBIDDAK_APP_ID : process.env.NEXT_PUBLIC_FIREBASE_APP_ID;
  const firebaseAppId = process.env.NEXT_PUBLIC_FIREBASE_APP_ID;
  const firebaseConfig: FirebaseOptions = {
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_API_KEY,
    appId: firebaseAppId,
  };

  useEffect(() => {
    if (userClickedYes) {
      setIsShown(false);
      if(navigator?.serviceWorker !== undefined){
        const app = initializeApp(firebaseConfig);
        const messaging: Messaging = getMessaging(app);
        getToken(messaging, {
          vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPIDKEY,
        })
            .then((token) => {
              console.log("Firebase Token:");
              console.log(token);
              if (token) {
                if (isLoggedInSso) {
                  firebaseRegister(token.toString());
                }
                const decodedToken =  decodeURIComponent(token)
                setCookie(null, CookiesConstants.FIREBASE_FCM_TOKEN, decodedToken);
                let url = `/firebase-admin-internal?locale=${locale}`;
                return __postAjaxClient(url, { token });
              }
            })
            .catch((e) => {
              console.error("firebaseError", e);
            });
      }

    }
  }, [userClickedYes]);

  useEffect(() => {
    if (userClickedNo) {
      const expiredDays = Number(
        process.env.NEXT_PUBLIC_NOTIFICATION_PERMISSION_EXPIRED_DAYS || "20"
      );
      const expires = new Date(
          new Date().getTime() + expiredDays * 24 * 60 * 60 * 1000
      );
      setCookie(null, CookiesConstants.FIREBASE_FCM_TOKEN, NO_VALUE  , {expires});
      setIsShown(false);
    }
  }, [userClickedNo]);

  return {
    showUi: isShown,
    onClickYes: () => {
      setUserClickedYes(true)
      Notification.requestPermission().then(function(permission) {
        if (permission === "granted") {
          permissionNotificationAction({actionNameLvl3:EnumActionNameLevel3.ALLOW})
        }else if(permission === "denied"){
          permissionNotificationAction({actionNameLvl3:EnumActionNameLevel3.DENY})
        }
      })
    },
    onClickNo: () => {
      permissionNotificationAction({actionNameLvl3:EnumActionNameLevel3.DENY})
      setUserClickedNo(true)
    },
  };
};
